import { useParams } from 'react-router-dom';
import { RubrosFormState } from '../../../context/rubros/RubrosFormState';
import { Form } from './form';
import useDocumentTitle from '../../../components/Title';

export const RubrosFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Rubro" : "Crear Rubro";
  useDocumentTitle(title);

  return (
    <RubrosFormState>
        <Form title={title} />
    </RubrosFormState>
  );
};